// extracted by mini-css-extract-plugin
module.exports = {"banner-picture":"banner-picture-aa0618281c136bb8b9d457701ed3168f"};